import { ReactNode } from 'react'
import { Flex } from '@dd3tech/wiggui/Flex'
import { composeClasses } from '../../../utils/src/strings'

interface OptionsSwitchProps {
  options: {
    value: string
    label: ReactNode | JSX.Element
  }[]
  onChange: (value: string) => void
  activeOption: string
  className?: string
  classNameOption?: string
  checkBlack?: boolean
}

export const OptionsSwitch = ({
  activeOption,
  onChange,
  options,
  className,
  classNameOption,
  checkBlack = false
}: OptionsSwitchProps) => {
  return (
    <Flex
      dir="row"
      justify="center"
      items="center"
      className={composeClasses(
        className,
        'w-fit p-1 gap-1 md:gap-2 rounded-full bg-surface-bg-black'
      )}
    >
      {options?.map((option) => {
        const isActive = option?.value === activeOption
        return (
          <Flex
            as="button"
            key={option?.value}
            className={composeClasses(
              classNameOption,
              'px-2 py-1 transition-all text-body-s duration-300 ease-in-out rounded-full min-w-[80px] justify-center',
              isActive
                ? `${
                    checkBlack
                      ? 'bg-primary text-white'
                      : 'bg-white text-primary font-semibold'
                  }`
                : 'text-white'
            )}
            onClick={() => onChange(option?.value)}
          >
            {option?.label}
          </Flex>
        )
      })}
    </Flex>
  )
}
